import React, { useState, useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Header from '../../../Header/Header';
import Spinner from '../../../Spinner/Spinner';
import PPQuizTaker from '../PPQuizTaker/PPQuizTaker';
import loaderColors1 from '../../../Spinner/loaderColors1.gif';
import { withAuth, handleResponse, handleJwtTokenForKeppMeLoggedIn } from "../../../../app/util/HOC";
export function PPPracticeQuiz() {
    const history = useHistory();
    const isLandingPageInfor = useRef(false);
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const { isbn, subtopictagid, subjectareatagid } = useParams();
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const authToken = userVO.apJwtAuthenticationToken ? userVO.apJwtAuthenticationToken : localStorage.getItem('apJwtAuthenticationToken');
    const [videoPPQuiz, setVideoPPQuiz] = useState('');
    const [isPraQuizLoad, setIsPraQuizLoad] = useState(true);
    const [ppQuizResultVO, setPpQuizResultVO] = useState('');
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    const getPostPPQuizInstance = async () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "quizVO": {
                "isGraded": false,
                "quizType": "video",
                "subTopicTagId": [subtopictagid],
            },
            "ppSubjectAreaTagId": subjectareatagid
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/PP/postPPQuizInstance`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then((data) => {
                setPpQuizResultVO(data.PpQuizResultVO);
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    const getVideoPPQuiz = async () => {
        let reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "keepMeLoggedInFlag": keepMeLogIn,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                },
                "sessionVO": getSessionVO()
            },
            "quizDetails": {
                "type": "Video",
                "isGraded": ppQuizResultVO.isGraded,
                "instanceId": ppQuizResultVO.instanceId
            },
            "associatedMetadataMappings": { "identifier": subtopictagid }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
        };
        fetch(`${localStorage.getItem('qpAPI')}/PP/getVideoPPQuiz/${subtopictagid}`, requestOptions)
            .then(handleResponse)
            .then(response => response.json())
            .then(handleJwtTokenForKeppMeLoggedIn)
            .then((data) => {
                if (data) {
                    setVideoPPQuiz(data);
                    setIsPraQuizLoad(false);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        if (
            localStorage.getItem('ppQuizInstances') === null ||
            localStorage.getItem('ppQuizInstances') === "undefined" ||
            localStorage.getItem('ppQuizInstances') === undefined
        ) {
            getPostPPQuizInstance();
        } else {
            var ppQuizInstances = JSON.parse(localStorage.getItem('ppQuizInstances'));
            if ((ppQuizInstances.instanceId === undefined && ppQuizInstances.incompleteQuizInstanceId === undefined)) {
                getPostPPQuizInstance();
            } else {
                setPpQuizResultVO(ppQuizInstances);
            }
        }
    }, []);
    useEffect(() => {
        if (isLandingPageInfor.current) {
            if (history.action === "POP") {
                history.push(`/pp-video-library/${isbn}`);
            } else {
                getVideoPPQuiz();
            }
        } else {
            if (history.action === "POP") {
                history.push(`/pp-video-library/${isbn}`);
            } else {
                isLandingPageInfor.current = true;
            }
        }
    }, [ppQuizResultVO]);
    return (
        <>
            <Spinner
                loading={isPraQuizLoad}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <Header userVO={userVO} pageName="CCPracticePerfect" isbn={isbn} time="test"></Header>
            <div>
                <div className="ppQuizNotifiContainer">
                    <div style={{ textAlign: "center" }} className="display-inline-block ppQuizNotifiTxt col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        PracticePerfect content is for personal use only. Redistribution is strictly prohibited. &copy; Aspen Publishing
                    </div>
                </div>
            </div>
            {
                (videoPPQuiz) ? <PPQuizTaker ppQuizResultVO={ppQuizResultVO} videoPPQuiz={videoPPQuiz} /> : null
            }
        </>
    )
}
export default withAuth(PPPracticeQuiz);